const configuration = {
  SOCKET_ENDPOINT: "wss://socket.dingus.fun/",
  API_ENDPOINT: "https://api.dingus.fun/",
};

export default configuration;
